import api from './api';

const siteService = {
  getAllSites: async () => {
    const response = await api.get('/api/sites');
    return response.data;
  },

  getSitesForStudy: async (studyID) => {
    const response = await api.get(`/api/studies/${studyID}/sites`);
    // Extract the sites array from the response
    return response.data.sites || [];
  },

  addSite: async (studyID, siteData) => {
    const response = await api.post(`/api/studies/${studyID}/add-site`, siteData);
    return response.data;
  },

  getSiteDetails: async (siteId) => {
    const response = await api.get(`/api/sites/${siteId}/edit/`);
    return response.data;
  },

  getSiteDetailsForStudy: async (studyID, siteID) => {
    const response = await api.get(`/api/studies/${studyID}/sites/${siteID}/details`);
    return response.data;
  },

  updateSite: async (siteId, siteData) => {
    const response = await api.put(`/api/sites/${siteId}/edit/`, siteData);
    return response.data;
  },



};

export default siteService;